import React from 'react';

/** The address every enquiry error and fallback points to. */
export const CONTACT_EMAIL = 'hello@tappd.app';

/**
 * The text with every "hello@tappd.app" as a working mailto link (the other words stay
 * plain text). Used by the enquiry errors and the dialogs' load-error panel.
 */
export function withContactLink(text) {
  const parts = String(text || '').split(CONTACT_EMAIL);
  return parts.map((part, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 ? (
        <a href={`mailto:${CONTACT_EMAIL}`} className="font-semibold text-navy underline underline-offset-2 hover:text-brand-rust">
          {CONTACT_EMAIL}
        </a>
      ) : null}
    </React.Fragment>
  ));
}
